module.exports = __webpack_public_path__ + "img/cn-pro-2-t.642b7005.png";